import _ from "lodash";

export class FacetsController {
	constructor($scope, $location, searchService) {
		this.facetGroups = searchService.getFacetGroups();
		this.searchService = searchService;
		this.location = $location;

		$scope.$watch( () => {
			return searchService.getFacetGroups();
		}, () => {
			this.facetGroups = searchService.getFacetGroups();
		}, true);
	}

	update() {
		var routeBuilder = this.searchService.getRouteBuilder();
		this.location.search(routeBuilder.getRoute());
		this.searchService.query();
	}

	clearGroup(groupId) {
		var facets = this.searchService.getFacetGroup(groupId).getSelectedFacets();
		_.each(facets, facet => { facet.selected = false } );
		this.update();
	}

}

FacetsController.$inject = ['$scope', '$location', 'searchService'];